import type { AdminClientContext, AdminHttpClient } from './client.js';
import type { AuditListQuery } from '../../../shared-types/src/index.js';

type MethodKeys =
  | 'getPartnerWebSearchUsage'
  | 'partnerGetOwnWebSearchUsage'
  | 'usageSummary'
  | 'usageSeries'
  | 'usageEvents'
  | 'usageExport'
  | 'creditSettlement'
  | 'creditSettlementExport'
  | 'usageVerify'
  | 'listAudit';

export function buildUsageMethods(ctx: AdminClientContext) {
  const { transport, token } = ctx;

  return {
    getPartnerWebSearchUsage: (partnerId, query) =>
      transport.getPartnerWebSearchUsage(token(), partnerId, query),
    partnerGetOwnWebSearchUsage: (query) =>
      transport.partnerGetOwnWebSearchUsage(token(), query),
    usageSummary: (query) => transport.usageSummary(token(), query),
    usageSeries: (query) => transport.usageSeries(token(), query),
    usageEvents: (query) => transport.usageEvents(token(), query),
    usageExport: (query) => transport.usageExport(token(), query),
    creditSettlement: (query) => transport.creditSettlement(token(), query),
    creditSettlementExport: (query) => transport.creditSettlementExport(token(), query),
    usageVerify: (query) => transport.usageVerify(token(), query),
    listAudit: ((query?: AuditListQuery) =>
      query
        ? transport.listAudit(token(), query)
        : transport.listAudit(token())) as AdminHttpClient['listAudit'],
  } satisfies Pick<AdminHttpClient, MethodKeys>;
}
